export default __webpack_public_path__ + "static/media/cta.e33c79ff.jpg";